import { Context, useContext } from 'react'
import { ConfigContext } from '../../shared-providers'
import { currentConfig } from '@/configs'

type contextType = Context<typeof currentConfig | Record<string, never>>

export const useConfig = () => {
  return useContext(ConfigContext as contextType)
}
